import React from "react";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * PageContainer
 * - Standard page frame: max-width, gutters, vertical padding.
 * - Uses tokenized text and background by default (override via className if needed).
 */
export function PageContainer({ className = "", children, ...props }) {
  return (
    <div
      className={cx(
        // Width + gutters + vertical rhythm (tokenized via Tailwind config)
        "mx-auto w-full max-w-[1200px] px-4 sm:px-6 md:px-8 py-4 md:py-6",
        // Default tokens for background/text (aligns with canon)
        "text-succession-text-primary bg-succession-bg-secondary",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}


